import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CallService } from 'src/app/services/http/call/call.service';
import { UtilsService } from 'src/app/services/tools/utils.service';
import { ListInstallationsMESAndInstallees } from 'src/app/model/call/call.model';


@Component({
  selector: 'app-extraction-machines-installees',
  templateUrl: './extraction-machines-installees.component.html',
  styleUrls: ['./extraction-machines-installees.component.scss']
})
export class ExtractionMachinesInstalleesComponent implements OnInit {

  public form !: FormGroup;
  public loading: boolean = false;
  public data !: any;
  public installation !: ListInstallationsMESAndInstallees;
  public list: ListInstallationsMESAndInstallees[] = [];

  get displayedColumns(): string[] {
    const result: string[] = ['numSerie', 'nomInstallation', 'dateInstallation', 'dateMiseEnService', 'dateArret', 'raisonSocial', 'codeEBP', 'codePostal'];
    return result;
  }

  constructor(private service: CallService, private builder: FormBuilder, private utils: UtilsService) { }

  ngOnInit(): void {
    this.form = this.builder.group({
      startDate: ['', Validators.required],
      endDate: ['', Validators.required]
    }
    );
  }


  public getNiceDate(date: string) {
    if (this.utils.getNiceDate(date) == '01/01/1970') {
      return "-";
    }

    return this.utils.getNiceDate(date);
  }


  public onSubmit() {
    if (!this.form.valid) {
      return;
    }

    this.loading = true;

    let startDate = this.form.controls.startDate.value;
    let endDate = this.form.controls.endDate.value;

    this.service.getInstallationsInstalleesAndMes(startDate, endDate).subscribe((data) => {
      this.data = data;
      this.list = [];
        const computeInstallations = this.data.reduce((dict:any, data : any) => {
          if (!dict[data.NUMERO_SERIE]) dict[data.NUMERO_SERIE] = [];
          dict[data.NUMERO_SERIE].push(data);
          return dict;
        }, {});

      
      for ( let elt in computeInstallations ) {
        let element = computeInstallations[elt];
        this.attributeCorrectDate(element);
      }

      this.loading = false;
      console.log(this.list);
    })


  }

  public attributeCorrectDate(elt : any) : ListInstallationsMESAndInstallees[]  {
    let installation : ListInstallationsMESAndInstallees = new ListInstallationsMESAndInstallees();
    let installDefault = null; 
    let mesDefault = null;
    let arretDefault = null;

    for ( let e of elt ) {
      installation.numero_serie = e.NUMERO_SERIE;
      installation.nom_installation = e.NOM_INSTALLATION
      installation.code_EBP = e.CODE_EBP;
      installation.code_postal = e.CODE_POSTAL;
      installation.raison_sociale = e.RAISON_SOCIALE;
      installation.date_installation = e.STATUT == 2 ? e.DATE_MODIFICATION : installDefault;
      installation.date_MES = e.STATUT == 3 ? e.DATE_MODIFICATION : mesDefault;
      installation.date_arret = e.STATUT == 4 ? e.DATE_MODIFICATION : arretDefault;
      installDefault = installation.date_installation;
      mesDefault = installation.date_MES;
      arretDefault = installation.date_arret;

    }

    if ( installation.date_installation) {
      this.list.push(installation);
    }

    return this.list;
  } 


}
